var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 34,
    viewBox: "0 0 26 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3198 1.70804C16.3198 1.14028 15.8591 0.676645 15.2925 0.712386C13.5007 0.825401 11.7375 1.23346 10.0745 1.92229C8.09448 2.74244 6.2954 3.94455 4.77996 5.45998C3.26453 6.97542 2.06242 8.7745 1.24227 10.7545C0.422124 12.7345 -1.8736e-07 14.8567 0 16.9998C1.8736e-07 19.143 0.422125 21.2651 1.24227 23.2452C2.06242 25.2252 3.26453 27.0242 4.77997 28.5397C6.2954 30.0551 8.09448 31.2572 10.0745 32.0774C11.7375 32.7662 13.5007 33.1743 15.2925 33.2873C15.8591 33.323 16.3198 32.8594 16.3198 32.2916L16.3198 1.70804Z",
    fill: "url(#paint0_linear_1020_6814)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0582 5.04949C25.0582 4.48173 24.5971 4.01706 24.0312 4.06379C21.0332 4.31138 18.2051 5.63703 16.0625 7.82285C13.6767 10.2568 12.3364 13.558 12.3364 17.0002C12.3364 20.4424 13.6767 23.7436 16.0625 26.1776C18.2051 28.3634 21.0332 29.689 24.0312 29.9366C24.5971 29.9834 25.0582 29.5187 25.0582 28.9509V5.04949Z",
    fill: "url(#paint1_linear_1020_6814)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1020_6814",
    x1: -0.197901,
    y1: 36.7494,
    x2: 25.3428,
    y2: -3.39829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0194FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FF8D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1020_6814",
    x1: 12.1822,
    y1: 32.6885,
    x2: 32.6305,
    y2: 1.1459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0194FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1FF8D1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.54bf805434215d09aea2ccb9d4f90e0e.svg";
export { ForwardRef as ReactComponent };